import api from 'api/axiosInstance';
import type { PromotionFromAPI } from 'types/promotions.types';
import { AvailableCountries } from 'types/users.types';

const getPromotions = (
  country: AvailableCountries,
): Promise<{ promotions: PromotionFromAPI[] }> =>
  api.get('/v1/subscriptions/stripe/promotions' + `?country=${country}`);

export default getPromotions;
export type { PromotionFromAPI } from 'types/promotions.types';
